import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
 const token = localStorage.getItem("tt_token");
 if (token) config.headers.Authorization = `Bearer ${token}`;
 return config;
});

api.interceptors.response.use(
 (r) => r,
 (err) => {
 if (err.response?.status === 401) {
 localStorage.removeItem("tt_token");
 localStorage.removeItem("tt_user");
 if (!window.location.pathname.match(/^\/(login|register|pricing|)$/)) {
 window.location.href = "/login";
 }
 }
 // Surface a friendly upsell toast on 402 quota errors. Boost-eligible
 // tiers get a "Boost" CTA; free users get an "Upgrade" CTA. Importing
 // toast/router here would create a circular dep, so we dispatch a
 // global event the AuthLayout listens for.
 if (err.response?.status === 402 && typeof window !== "undefined") {
 const boostAvailable = err.response.headers?.["x-boost-available"];
 const detail = err.response.data?.detail || "Out of queries this month.";
 window.dispatchEvent(new CustomEvent("tt:quota-exceeded", {
 detail: { message: detail, boost: boostAvailable || null },
 }));
 }
 return Promise.reject(err);
 }
);

export default api;
